export const toFirstCharUppercase = name =>
  name.charAt(0).toUpperCase() + name.slice(1);
